export const siteName = '黑料六点';

export const navItems = [
  { label: '今日六点', href: '#feed' },
  { label: '热度榜', href: '#ranking' },
  { label: '反转追踪', href: '#reversal' },
  { label: '题材速览', href: '#topics' },
  { label: '值班精选', href: '#picks' },
  { label: '更新提醒', href: '#reminder' },
];

export const editionInfo = {
  episode: '第 1,204 期',
  slot: '今日 18:00 场',
  desk: '值守台 · 三位编辑在线',
  updatedAt: '17:58 已预热',
};

export const tickerItems = [
  '17:42 补充 · 头部美妆主播提及合约分成，直播间片段被搬运',
  '17:15 反转 · 旅行综艺停录传闻，节目通告显示正常排期',
  '16:50 首发 · 剧组换角传闻，片方回应以官宣为准',
  '16:20 跟进 · 战队首发名单临时调整，后援会发文',
  '15:45 首发 · 某饮品代言海报撤下，官方店铺仍保留',
  '15:10 补充 · 巡演加场公告删除又恢复，票务余票可见',
  '14:30 反转 · 退役传言遭本人点赞辟谣，评论区已关闭',
];

export const heroFeature = {
  tag: '六点首发',
  topic: '娱乐圈',
  title: '某新生代男演员被拍夜会导演，工作室暂未回应',
  summary:
    '昨日深夜的行程路透先在小范围流传，今早被多个账号搬运后热度抬升。目前仅有一组时间线照片，尚未出现双方正面回应，编辑已向经纪团队发起求证。',
  heat: 12840,
  heatLabel: '站内热度',
  followed: 6,
  time: '18:00',
  image:
    'https://readdy.ai/api/search-image?query=abstract%20dark%20amber%20newsroom%20spotlight%20with%20floating%20paper%20documents%20and%20glowing%20timeline%20grid%2C%20moody%20editorial%20investigation%20atmosphere%2C%20dramatic%20warm%20lighting%2C%20minimal%20composition%2C%20high%20contrast&width=960&height=640&seq=hl6-hero-01&orientation=landscape',
};

export const heroSideCards = [
  {
    id: 'side-1',
    label: '今日六点整发布',
    value: '18:00',
    hint: '到点自动汇总新瓜与反转折点',
    tone: 'primary' as const,
    icon: 'ri-timer-flash-line',
  },
  {
    id: 'side-2',
    label: '今日榜首',
    value: '美妆主播合约分成口误',
    hint: '热度 9,620 · 较昨日 +38%',
    tone: 'accent' as const,
    icon: 'ri-fire-line',
  },
  {
    id: 'side-3',
    label: '今日收录',
    value: '128 条',
    hint: '其中首发 46 条 · 补充 52 条',
    tone: 'secondary' as const,
    icon: 'ri-inbox-archive-line',
  },
  {
    id: 'side-4',
    label: '待核实焦点',
    value: '《长夜列车》换角',
    hint: '片方仅回应"以官宣为准"',
    tone: 'secondary' as const,
    icon: 'ri-question-mark',
  },
];

export const fastFacts = [
  { label: '跟进事件', value: '36 起' },
  { label: '确认反转', value: '7 起' },
  { label: '值守编辑', value: '12 人' },
];

export const feedTopics = ['全部', '娱乐圈', '网红圈', '影视', '综艺', '电竞', '品牌', '音乐', '体育'];

export const feedItems = [
  {
    id: 'feed-1',
    time: '18:00',
    tag: '首发',
    topic: '娱乐圈',
    title: '某新生代男演员被拍夜会导演，工作室暂未回应',
    summary: '行程路透与时间线照片同时出现，双方团队均未发布正式说明，编辑已发出求证。',
    heat: 12840,
    follow: '跟进中',
  },
  {
    id: 'feed-2',
    time: '17:42',
    tag: '补充',
    topic: '网红圈',
    title: '头部美妆主播直播间口误提及合约分成，片段被大量搬运',
    summary: '原片段来自昨日场次，今日被剪辑成多个版本传播，当事主播尚未正面回应。',
    heat: 9620,
    follow: '跟进中',
  },
  {
    id: 'feed-3',
    time: '17:15',
    tag: '反转',
    topic: '综艺',
    title: '传某旅行综艺停录，节目组通告显示正常排期',
    summary: '上午的停录传闻在通告流出后出现反转折点，站姐路透也已同步出现。',
    heat: 7345,
    follow: '已反转',
  },
  {
    id: 'feed-4',
    time: '16:50',
    tag: '首发',
    topic: '影视',
    title: '《长夜列车》剧组换角传闻，片方回应"以官宣为准"',
    summary: '换角说法来自匿名贴，片方回应未直接否认，演员经纪人相关动态已被删除。',
    heat: 6880,
    follow: '待核实',
  },
  {
    id: 'feed-5',
    time: '16:20',
    tag: '跟进',
    topic: '电竞',
    title: '战队首发名单临时调整，粉丝后援会发文',
    summary: '官方公布的名单与训练赛阵容不一致，后援会呼吁以赛事方公告为准。',
    heat: 5410,
    follow: '跟进中',
  },
  {
    id: 'feed-6',
    time: '15:45',
    tag: '首发',
    topic: '品牌',
    title: '某饮品代言海报撤下，官方店铺仍保留',
    summary: '海报在部分渠道被替换，客服口径为常规物料轮换，官方尚未给出进一步说明。',
    heat: 4980,
    follow: '待核实',
  },
  {
    id: 'feed-7',
    time: '15:10',
    tag: '补充',
    topic: '音乐',
    title: '歌手巡演加场公告删除又恢复，票务平台显示余票',
    summary: '公告在发布两小时后短暂消失，随后原样恢复，加场城市未发生变动。',
    heat: 3640,
    follow: '跟进中',
  },
  {
    id: 'feed-8',
    time: '14:30',
    tag: '反转',
    topic: '体育',
    title: '退役传言遭本人点赞辟谣，评论区已关闭',
    summary: '多个账号同步发布退役消息，本人在相关辟谣帖下点赞，但未发布长文说明。',
    heat: 2915,
    follow: '已反转',
  },
];

export const rankingItems = [
  { rank: 1, title: '某新生代男演员夜会导演', heat: 12840, trend: 'up' as const, topic: '娱乐圈' },
  { rank: 2, title: '美妆主播合约分成口误', heat: 9620, trend: 'up' as const, topic: '网红圈' },
  { rank: 3, title: '旅行综艺停录传闻反转', heat: 7345, trend: 'down' as const, topic: '综艺' },
  { rank: 4, title: '《长夜列车》换角风波', heat: 6880, trend: 'flat' as const, topic: '影视' },
  { rank: 5, title: '战队首发名单临时调整', heat: 5410, trend: 'up' as const, topic: '电竞' },
  { rank: 6, title: '饮品代言海报撤下', heat: 4980, trend: 'down' as const, topic: '品牌' },
  { rank: 7, title: '巡演加场公告删除又恢复', heat: 3640, trend: 'up' as const, topic: '音乐' },
  { rank: 8, title: '退役传言遭本人点赞辟谣', heat: 2915, trend: 'down' as const, topic: '体育' },
];

export const reversalItems = [
  {
    id: 'rev-1',
    topic: '综艺',
    title: '旅行综艺停录',
    first: '网传因嘉宾档期冲突，节目暂停录制。',
    latest: '节目组通告显示正常排期，站姐路透同步出现。',
    stage: '已反转' as const,
    updatedAt: '17:15',
  },
  {
    id: 'rev-2',
    topic: '影视',
    title: '《长夜列车》换角',
    first: '匿名贴称某演员被临时替换。',
    latest: '片方称"以官宣为准"，演员经纪人删除相关动态。',
    stage: '待核实' as const,
    updatedAt: '16:50',
  },
  {
    id: 'rev-3',
    topic: '网红圈',
    title: '美妆主播合约分成',
    first: '直播中提及平台抽成比例。',
    latest: '直播回放该片段被剪辑，主播未正面回应。',
    stage: '存疑' as const,
    updatedAt: '17:42',
  },
  {
    id: 'rev-4',
    topic: '体育',
    title: '运动员退役传言',
    first: '多家自媒体同步称其即将退役。',
    latest: '本人点赞辟谣帖，未发布长文说明。',
    stage: '已反转' as const,
    updatedAt: '14:30',
  },
];

export const topicBoard = [
  { name: '娱乐圈', count: 38, hot: '演员行程 / 剧组动态' },
  { name: '网红圈', count: 24, hot: '直播片段 / 商务合作' },
  { name: '影视', count: 19, hot: '换角 / 定档 / 物料' },
  { name: '综艺', count: 16, hot: '录制排期 / 嘉宾阵容' },
  { name: '电竞', count: 12, hot: '名单 / 转会 / 赛事' },
  { name: '品牌', count: 11, hot: '代言 / 物料 / 客服口径' },
  { name: '音乐', count: 8, hot: '巡演 / 加场 / 票务' },
  { name: '体育', count: 6, hot: '转会 / 退役 / 赛程' },
];

export const editorPicks = [
  {
    id: 'pick-1',
    tag: '编辑视角',
    title: '同一条路透，为什么上午和下午的解读完全不同',
    excerpt: '把时间线摊开看，你会发现热度抬升的节点不在照片本身，而在第二个搬运账号的措辞变化上。',
    author: '值班编辑 · 老 K',
    time: '17:50',
    image:
      'https://readdy.ai/api/search-image?query=minimal%20studio%20microphone%20and%20notebook%20on%20warm%20amber%20desk%2C%20soft%20directional%20light%2C%20editorial%20investigation%20still%20life%2C%20clean%20simple%20background%2C%20muted%20warm%20tones&width=480&height=480&seq=hl6-pick-01&orientation=squarish',
  },
  {
    id: 'pick-2',
    tag: '反转笔记',
    title: '通告流出之前，那几条"内部消息"是怎么被证伪的',
    excerpt: '三条自称内部的消息有一个共同点：都只给了结论，没有任何可核对的时间点与出处。',
    author: '值班编辑 · 阿洲',
    time: '16:05',
    image:
      'https://readdy.ai/api/search-image?query=stack%20of%20printed%20documents%20with%20red%20correction%20marks%20on%20a%20dark%20warm%20table%2C%20close%20up%20editorial%20fact%20checking%20scene%2C%20moody%20amber%20light%2C%20minimal%20composition&width=480&height=480&seq=hl6-pick-02&orientation=squarish',
  },
  {
    id: 'pick-3',
    tag: '数据观察',
    title: '热度榜前十里有四条来自"补充"，而不是"首发"',
    excerpt: '今天的信息结构很典型：首发负责起势，真正把话题推到高位的是后续的补充与反转。',
    author: '值班编辑 · 小满',
    time: '15:20',
    image:
      'https://readdy.ai/api/search-image?query=abstract%20rising%20bar%20chart%20made%20of%20glowing%20amber%20light%20on%20deep%20warm%20background%2C%20data%20visualization%20art%2C%20minimal%20modern%20editorial%20style&width=480&height=480&seq=hl6-pick-03&orientation=squarish',
  },
];

export const reminderTips = [
  '只在到点时汇总，不打扰式推送',
  '新瓜 / 补充 / 反转分色标记',
  '可随时关闭，不关联任何账号',
];